<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- -->
        <!-- search -->
        <form @submit.prevent="onSubmit">
          <div class="field has-addons">
            <div class="control has-icons-left is-expanded is-fullwidth">
              <input v-model="search" type="text" class="input is-rounded" :placeholder="$t('faq.search_prompt')">
              <span class="icon is-small is-left">
                <i class="fa fa-search"></i>
              </span>
            </div>
            <div class="control">
              <button class="button is-primary is-rounded" type="submit">{{ $t("nav.search") }}</button>
            </div>
          </div>
        </form>
        <!-- -->
        <!-- -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Faq',
    data () {
      return {
        search: ''
      }
    },
    methods: {
      onSubmit () {
        const search = this.search
        if (!search) {
          return
        }
        if (search.length <= 42) {
          this.$router.push({name: 'Contract', params: { hash: search }})
        } else {
          this.$router.push({name: 'Transaction', params: { hash: search }})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content {
    align-items: center;
    min-height: 71vh;
  }

  form {
    margin-top: 4rem;
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Faq.vue